<template>
  <v-app :class="isSalonPage ? 'salon-fullscreen' : 'background-image'">
    <v-app-bar v-if="!isSalonPage" app color="black" dark>
      <v-img v-if="isAuthenticated" src="@/assets/logoWhite.png" alt="Logo" contain max-width="160"
        class="ma-5 mr-2"></v-img>
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn v-if="isAuthenticated" class="d-none d-md-flex"
        @click="showHelp = true; totalProgressAI = 0; userMessage = ''; responseMessage = ''" style="padding: 0;">
        <img :src="require('@/assets/Assistant_black.jpg')" style="max-width: 36px; border-radius: 50%;" />
      </v-btn>

      <v-btn v-if="isAuthenticated" text @click="navigateTo('Board')" color="white"
        class="mr-2 d-none d-md-flex">Home</v-btn>
      <v-btn v-if="isAuthenticated" text @click="navigateTo('BCorp')" color="white"
        class="mr-2 d-none d-md-flex">BCorp</v-btn>
      <v-btn v-if="isAuthenticated && producerStatus" text @click="navigateTo('Finder')" color="white"
        class="mr-2 d-none d-md-flex">Finder</v-btn>
      <v-btn v-if="isAuthenticated" text @click="navigateTo('Videos')" color="white"
        class="mr-2 d-none d-md-flex">Videos</v-btn>
      <v-btn v-if="isAuthenticated" text @click="navigateTo('Dashboard')" color="white"
        class="mr-2 d-none d-md-flex">Sender</v-btn>
      <v-btn v-if="isAuthenticated" icon @click="openMenu" ref="menuButton" class="d-none d-md-flex mr-2">
        <v-icon>mdi-account</v-icon>
      </v-btn>
      <v-btn v-if="isAuthenticated" icon @click="drawer = !drawer" class="d-md-none">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-if="!isSalonPage" v-model="drawer" app temporary>
      <v-list>
        <v-list-item v-if="isAuthenticated"
          @click="showHelp = true; totalProgressAI = 0; userMessage = ''; responseMessage = ''">
          <img :src="require('@/assets/Assistant.jpg')" style="max-width: 36px; border-radius: 50%;" />
        </v-list-item>
        <v-list-item v-if="isAuthenticated" @click="navigateTo('Board')">Home</v-list-item>
        <v-list-item v-if="isAuthenticated" @click="navigateTo('BCorp')">BCorp</v-list-item>
        <v-list-item v-if="isAuthenticated && producerStatus" @click="navigateTo('Finder')">Finder</v-list-item>
        <v-list-item v-if="isAuthenticated" @click="navigateTo('Videos')">Videos</v-list-item>
        <v-list-item v-if="isAuthenticated" @click="navigateTo('Dashboard')">Sender</v-list-item>
        <v-list-item v-if="isAuthenticated" @click="openMenu">
          <v-icon>mdi-account</v-icon>
          Account
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main :style="isSalonPage ? 'padding: 0 !important; margin: 0 !important;' : ''">
      <v-container v-if="!isSalonPage">
        <router-view></router-view>
      </v-container>
      <router-view v-else></router-view>
    </v-main>

    <v-dialog v-model="dialog" min-width="450" transition="dialog-top-transition">
      <v-card class="menu-dialog">
        <v-list>
          <v-list-item v-if="adminStatus" @click="AdminUser">
            <v-list-item-title><v-icon class="ma-2" color="blue-darken-2">mdi-account-multiple</v-icon>Users
              Manager</v-list-item-title>
          </v-list-item>
          <v-list-item @click="resetPassword">
            <v-list-item-title><v-icon class="ma-2" color="blue-darken-2">mdi-lock-reset</v-icon>Reset
              Password</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title><v-icon class="ma-2" color="blue-darken-2">mdi-logout</v-icon>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmationDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Password Reset</v-card-title>
        <v-card-text>Your password reset request has been sent. Please follow the instruction registraion
          again.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirmationDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHelp" max-width="600px" persistent scrollable style="margin-top: 8%;">
      <v-card>
        <v-card-title class="headline d-flex justify-space-between">
          E-People Assistant
          <v-btn icon @click="showHelp = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 500px;">
          <div>
            <v-form>
              <v-text-field v-model="userMessage" label="Message"
                placeholder="Ask for information about how the E-People portal works..." required
                outlined></v-text-field>
              <div class="d-flex align-items-center" style="width: 100%;">
                <v-progress-linear color="light-blue"
                  :indeterminate="!(totalProgressAI === 0 || totalProgressAI === 100)" max="100" height="35"
                  style="flex-grow: 1;border-radius: 5px;"></v-progress-linear>
                <v-btn @click="sendHelp" color="primary" style="margin-left: 10px;">Send</v-btn>
              </div>
            </v-form>
          </div>
          <div class="d-flex justify-space-between align-items-start mt-4">
            <!-- Messaggio di risposta -->
            <v-alert style="flex: 1;position: relative;background-color:rgb(198, 253, 235);">
              {{ responseMessage }}
              <!-- Icone per il feedback -->
              <div style="position: absolute; bottom: 5px; right: 5px;margin-top: 30px;">
                <v-btn :disabled="responseMessage === ''" small icon @click="openFeedbackModal('like')" style="background-color: transparent; width: 40px; height: 40px;margin-top: 5px; 
                  box-shadow: none; border: none; outline: none;">
                  <v-icon color="green">mdi-thumb-up</v-icon>
                </v-btn>

                <v-btn :disabled="responseMessage === ''" small icon @click="openFeedbackModal('dislike')" style="background-color: transparent; width: 40px; height: 40px; margin-left: 5px; margin-top: 5px; 
                  box-shadow: none; border: none; outline: none;">
                  <v-icon color="red">mdi-thumb-down</v-icon>
                </v-btn>
              </div>
            </v-alert>
            <!-- Robot container -->
            <div class="robot-container ml-4" style="width: 100px;">
              <img :src="isSpeaking ? require('@/assets/Assistant_talk.jpg') : require('@/assets/Assistant.jpg')"
                alt="Talking Robot" class="robot-face" width="100" />
              <!-- Bocca del robottino animata -->
              <div class="robot-mouth" style="white-space: pre-wrap;" v-if="isSpeaking"
                :class="{ 'speaking': responseMessage !== '' }"></div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFeedbackModal" max-width="500px" scrollable style="margin-top: 12%;">
      <v-card>
        <v-card-title class="headline">Feedback Comment</v-card-title>
        <v-card-text>
          <v-form>
            <v-textarea v-model="feedbackComment" label="Comment" placeholder="Leave your comment here..." rows="3"
              outlined></v-textarea>
          </v-form>
          <div class="d-flex justify-end mt-3">
            <v-btn @click="submitFeedback" color="primary">Submit</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      isAuthenticated: false,
      dialog: false,
      dialogStyle: {},
      confirmationDialog: false,
      drawer: false,
      showHelp: false,
      userMessage: '',
      responseMessage: '',
      totalProgressAI: 0,
      tokenAI: '',
      isSpeaking: false, // Stato per sapere se il robottino sta "parlando"
      showFeedbackModal: false,
      feedbackComment: '',
      feedbackType: '', // Tipo di feedback ('like' o 'dislike')            
    };
  },
  computed: {
    isSalonPage() {
      return this.$route.path === '/salon';
    },
    ...mapState(['isAdmin']),
    adminStatus: {
      get() {
        console.log('app isAdmin: ', this.isAdmin)
        return this.isAdmin;
      },
      set(value) {
        this.setAdminStatus(value);
      }
    },
    ...mapState(['isProducer']),
    producerStatus: {
      get() {
        console.log('isProducer: ', this.isProducer)
        return this.isProducer;
      },
      set(value) {
        console.log('isProducer set: ', value)
        this.setProducerStatus(value);
      }
    }
  },
  mounted() {
    this.checkAdminStatus();
    this.checkProducerStatus();
  },
  methods: {
    sendFeedback(type) {
      console.log('Feedback inviato:', type);
      // Aggiungi qui la logica per inviare il feedback al server, se necessario
      this.$bvToast.toast(`Feedback "${type}" ricevuto. Grazie!`, {
        title: 'Feedback',
        variant: 'info',
        solid: true
      });
    },
    openFeedbackModal(type) {
      console.log('OpenFeedback:', type)
      this.feedbackType = type;
      this.showFeedbackModal = true;
    },
    async submitFeedback() {
      try {
        const response = await axios.post(process.env.VUE_APP_SERVER2 + '/sendFeedbackEmail', {
          to: 'marco.principi@e-photo.it', // Destinatario dell'email
          subject: `Feedback su E-People Assistant (${this.feedbackType})`,
          text: `L'utente ha lasciato un feedback di tipo "${this.feedbackType}"`,
          comment: this.feedbackComment,
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 200) {
          this.feedbackComment = '';
          this.showFeedbackModal = false;
        } else {
          console.log('Errore durante l\'invio del feedback');
        }
      } catch (error) {
        console.error('Errore durante l\'invio del feedback:', error);
      }
    },
    async sendHelp() {
      this.tokenAI = process.env.VUE_APP_AI;
      const serverAI = process.env.VUE_APP_SERVER_AI;

      console.log('sendHelp: ', serverAI);

      if (!this.userMessage) {
        this.responseMessage = 'Please insert a message.';
        return;
      }
      //const pdfUrl = `${window.location.origin}/public/Manuale_Finder.pdf`;
      const fileContent = await fetch('/EPeople/Manuale_EPeople.txt').then(response => response.text());
      //console.log('file:',fileContent);
      this.totalProgressAI = 25;
      //asst_YdLTG6OEl6Y4JCvxHKb6WemQ
      try {
        const response = await fetch(serverAI + '/Auth/GetGPTAPI', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.tokenAI}`,
          },
          body: JSON.stringify({
            token: this.tokenAI,
            prompt: JSON.stringify({
              model: 'gpt-4o-mini',
              messages: [
                { role: 'system', content: 'Sei un assistente tecnico per fornire esclusivamente supporto in base alla documentazione tecnica disponibile al seguente link: ' + fileContent },
                { role: 'assistant', content: 'Il tuo nome è Sario' },
                { role: 'user', content: this.userMessage }
              ]
            })
          })
        });
        this.totalProgressAI = 75;
        const data = await response.json();
        console.log('ret data:', data);
        if (data.return) {
          this.responseMessage = data.return;
          this.startSpeakingAnimation(data.return.length); // Avvia l'animazione parlante in base alla lunghezza della risposta
        } else {
          this.responseMessage = 'Non sono riuscito a ottenere una risposta. Per favore riprova.';
        }
      } catch (error) {
        this.responseMessage = 'Si è verificato un errore. Per favore riprova più tardi.';
      } finally {
        this.totalProgressAI = 100;
      }
    },
    startSpeakingAnimation(responseLength) {
      this.isSpeaking = true;
      const duration = Math.min(Math.max(responseLength * 50, 2000), 10000); // Durata proporzionale alla lunghezza, minimo 2s e massimo 10s

      setTimeout(() => {
        this.isSpeaking = false;
      }, duration);
    },
    ...mapMutations(['setAdminStatus']),
    ...mapMutations(['setProducerStatus']),
    openMenu() {
      this.dialog = true;
    },
    AdminUser() {
      this.dialog = false;
      this.$router.push('/users');
    },
    checkAuth() {
      let token = localStorage.getItem('token');
      this.isAuthenticated = !!token;
    },
    checkAdminStatus() {
      const isAdmin = ((localStorage.getItem('isAdmin') == 'false') || (localStorage.getItem('isAdmin') == 0)) ? false : true;
      this.setAdminStatus(isAdmin === true);
    },
    checkProducerStatus() {
      const isProducer = (localStorage.getItem('isProducer') == 'false') ? false : true;
      this.setProducerStatus(isProducer === true);
    },
    navigateTo(route) {
      this.$router.push({ path: `/${route}` });
    },
    logout() {
      this.dialog = false;
      localStorage.removeItem('conversationId');
      localStorage.removeItem('token');
      localStorage.removeItem('isAdmin');
      this.isAuthenticated = false;
      this.setAdminStatus(false);
      this.setProducerStatus(false);
      this.$router.push('/login');
    },
    async resetPassword() {
      this.dialog = false;
      try {
        const token = localStorage.getItem('token');
        await axios.post(process.env.VUE_APP_SERVER3 + '/reset-password', {}, {
          headers: {
            Authorization: token
          }
        });
        this.confirmationDialog = true;
      } catch (error) {
        console.error('Error resetting password:', error);
      }
    }
  },
  created() {
    const currentUrl = window.location.href;
    // Utilizza il costruttore URL per ottenere il pathname dall'URL
    const pathname = new URL(currentUrl).pathname;
    // Estrai il nome della pagina rimuovendo il percorso e l'estensione
    const pageName = pathname.split('/').pop();
    console.log('Page Name:', pageName);
    if (!pageName)
      localStorage.removeItem('token');

    this.confirmationDialog = false;
    this.checkAuth();
    //this.checkProducerStatus();
  },
  watch: {
    '$route'() {
      this.checkAuth();
    },
  },
};
</script>

<style>
@import '~vuetify/dist/vuetify.min.css';

.robot-container {
  margin-top: 10px;
  position: relative;
  width: 100px;
  height: 100px;
}

.robot-face {
  width: 100%;
  height: auto;
}

.robot-mouth {
  position: absolute;
  bottom: 38%;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 10px;
  background-color: black;
  border-radius: 50%;
  opacity: 0;
}

.speaking {
  animation: talk 0.3s steps(2) infinite;
}

@keyframes talk {

  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

.background-image {
  background-image: url('@/assets/background.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.menu-dialog {
  position: fixed;
  top: -415px;
  right: -24px;
  z-index: 2000;
}

@media (max-width: 600px) {
  .menu-dialog {
    position: absolute;
    top: 5%;
    right: 50%;
    z-index: 2000;
  }
}

/* Fullscreen mode for salon page — override Vuetify layout */
.salon-fullscreen,
.salon-fullscreen .v-application__wrap {
  background: #0d0d1a !important;
  min-height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

.salon-fullscreen .v-main,
.salon-fullscreen .v-main__wrap {
  padding: 0 !important;
  margin: 0 !important;
}

.salon-fullscreen .v-layout,
.salon-fullscreen .v-main {
  --v-layout-top: 0px !important;
  --v-layout-bottom: 0px !important;
  --v-layout-left: 0px !important;
  --v-layout-right: 0px !important;
}

body:has(.salon-fullscreen) {
  margin: 0 !important;
  padding: 0 !important;
  background: #0d0d1a !important;
  overflow: hidden;
}
</style>
